
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 27581,
	"./src/base_page_params.ts": 3698,
	"./src/blueslip.ts": 67040,
	"./src/blueslip_stacktrace.ts": 33622,
	"./src/bot_types.ts": 23603,
	"./src/bundles/common.ts": 35013,
	"./src/bundles/marketing_page_bundle.ts": 85181,
	"./src/csrf.ts": 1156,
	"./src/loading_error.ts": 57553,
	"./src/portico/google-analytics.ts": 75781,
	"./src/portico/header.ts": 802,
	"./src/realm_user_settings_defaults.ts": 26646,
	"./src/retry_backoff.ts": 42797,
	"./src/sentry.ts": 333,
	"./src/state_data.ts": 80096,
	"./src/stream_types.ts": 2036,
	"./src/types.ts": 51441,
	"./src/user_settings.ts": 24729,
	"./src/user_status_types.ts": 10264,
	"./styles/portico/comparison_table.css": 22411,
	"./styles/portico/marketing_page.css": 97987,
	"./styles/portico/pricing_plans.css": 322,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"./templates/team/contributor_count.hbs": 36993,
	"./templates/team/contributors.hbs": 10175,
	"./templates/team/loading.hbs": 22581,
	"./templates/team/total_contributor_count.hbs": 90185,
	"@sentry/conventions/attributes": 59966,
	"core-js/modules/es.array-buffer.detached.js": 19000,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 32169,
	"core-js/modules/es.array-buffer.transfer.js": 60025,
	"core-js/modules/es.array.includes.js": 54508,
	"core-js/modules/es.array.push.js": 94361,
	"core-js/modules/es.iterator.constructor.js": 16608,
	"core-js/modules/es.iterator.filter.js": 79944,
	"core-js/modules/es.iterator.find.js": 70001,
	"core-js/modules/es.iterator.flat-map.js": 27454,
	"core-js/modules/es.iterator.map.js": 72542,
	"core-js/modules/es.iterator.reduce.js": 79992,
	"core-js/modules/es.iterator.some.js": 75390,
	"core-js/modules/es.iterator.to-array.js": 81779,
	"core-js/modules/es.json.parse.js": 9999,
	"core-js/modules/es.json.stringify.js": 27761,
	"core-js/modules/es.map.get-or-insert-computed.js": 47180,
	"core-js/modules/es.map.get-or-insert.js": 40870,
	"core-js/modules/es.set.difference.v2.js": 93535,
	"core-js/modules/es.set.intersection.v2.js": 2665,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 18052,
	"core-js/modules/es.set.is-subset-of.v2.js": 92025,
	"core-js/modules/es.set.is-superset-of.v2.js": 54402,
	"core-js/modules/es.set.symmetric-difference.v2.js": 36617,
	"core-js/modules/es.set.union.v2.js": 54725,
	"core-js/modules/es.typed-array.with.js": 10722,
	"core-js/modules/es.uint8-array.set-from-base64.js": 61693,
	"core-js/modules/es.uint8-array.set-from-hex.js": 48789,
	"core-js/modules/es.uint8-array.to-base64.js": 33775,
	"core-js/modules/es.uint8-array.to-hex.js": 72791,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"lodash": 35558,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021
};